import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { getIconColorSVGFill } from '../../tools/colors.js';
import css_248z from './icons.styles.css.js';

let ChatbotIcon = class ChatbotIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.color = 'iconNeutralSoft';
        this.size = '24';
    }
    render() {
        return html `
      <svg
        width=${`${this.size}px`}
        height=${`${this.size}px`}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 23V7.96603C4 7.50666 4.16356 7.11341 4.49069 6.78628C4.81782 6.45916 5.21107 6.29559 5.67044 6.29559H19.0339C19.4933 6.29559 19.8865 6.45916 20.2137 6.78628C20.5408 7.11341 20.7044 7.50666 20.7044 7.96603V17.9886C20.7044 18.448 20.5408 18.8413 20.2137 19.1684C19.8865 19.4955 19.4933 19.6591 19.0339 19.6591H7.34087L4 23ZM6.63094 17.9886H19.0339V7.96603H5.67044V18.9283L6.63094 17.9886Z"
          fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        />
        <ellipse
          cx="14.8043"
          cy="11.7689"
          rx="1.27948"
          ry="1.27948"
          fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        />
        <ellipse
          cx="12.2455"
          cy="2.27948"
          rx="1.27948"
          ry="1.27948"
          fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        />
        <ellipse
          cx="9.79303"
          cy="11.7689"
          rx="1.27948"
          ry="1.27948"
          fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        />
        <path
          d="M9.36682 15.0209V15.0209C11.2429 15.8055 13.3551 15.8055 15.2311 15.0209V15.0209"
          stroke=${this.color
            ? getIconColorSVGFill(this.color)
            : 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <rect
          x="11.7832"
          y="3.13245"
          width="1.06624"
          height="3.19871"
          fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        />
      </svg>
    `;
    }
};
ChatbotIcon.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], ChatbotIcon.prototype, "color", void 0);
__decorate([
    property({ type: String })
], ChatbotIcon.prototype, "size", void 0);
ChatbotIcon = __decorate([
    customElement('chatbot-icon')
], ChatbotIcon);
var ChatbotIcon$1 = ChatbotIcon;

export { ChatbotIcon$1 as default };
//# sourceMappingURL=chatbotIcon.js.map
